import React, { useMemo } from 'react';
import { encode } from 'html-entities';
import './index.less';
import { environment } from '@gaodun.com/gtools';
import { IQuestionListItem } from '@/types';

interface IProps {
    questionItem: IQuestionListItem;
}

const CorrectAiContent: React.FC<IProps> = props => {
    const { aiCorrect, score, userAnswer, projectId, subjectId } = props.questionItem;
    // 用户答案
    const userValue = userAnswer?.userAnswer || '';
    /**
     * summary AI 解析
     * correctStatus 批改状态
     * props.children 你的回答
     */
    const { correctStatus, pointList = [], totalScore, summary, totalScoreStr } = aiCorrect!;

    /**
     * 1.处理返回关键字匹配不到的字段
     * 2.将数组转换为一维数组便于操作 并且标识出有分数的字符串
     * 3.将相同的字符串分数合并
     */
    const resolvePlanList = useMemo(() => {
        const newList: { score: number; str: string }[] = [];
        const resultArr: { score: number; str: string }[] = [];

        pointList.forEach(item => {
            item.content
                .filter(child => String(userAnswer?.userAnswer).includes(child))
                .forEach((str, index, arr) => {
                    newList.push({
                        score: arr.length === index + 1 ? item.score : 0,
                        str,
                    });
                });
        });

        newList.sort((a, b) => b.str.length - a.str.length);

        newList.forEach(item => {
            // 在结果数组中查找是否已经存在相同的字符串
            const existingItem = resultArr.find(result => result.str === item.str || result.str.endsWith(item.str));
            if (existingItem) {
                // 如果存在，将分数加到已存在的对象上，然后将当前对象的分数设为0
                existingItem.score += item.score;
                item.score = 0;
            }
            // 将处理后的对象添加到结果数组中
            resultArr.push(item);
        });

        return resultArr;
    }, [pointList]);

    const matchKeyWord = () => {
        let initValue = encode(String(userAnswer?.userAnswer));
        resolvePlanList.forEach(item => {
            initValue = initValue.replace(
                item.str,
                `<span class="artScorePoint">${item.str}<span class="artScore">${item.score ? item.score + '分' : ''}</span></span>`
            );
        });
        return initValue;
    };

    const goComment = () => {
        window.open(
            `https://${environment.getApiEnv()}muses.gaodun.com/ape/evaluation-page?businessUnitId=${
                aiCorrect!.id
            }&scene=15&version=体验监测V1.0&projectId=${projectId}&subjectId=${subjectId}`
        );
    };

    const renderStatusContent = () => {
        switch (correctStatus) {
            case 1:
                return (
                    <div className="ai-correct-loading">
                        <img
                            className="ai-header-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202310/30/04c33_20231030162720.png"
                        />
                        <div>批改需3-10分钟。请先做其他学习，结果稍后显示。感谢等待。</div>

                        <img
                            className="ai-voice-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202305/24/5f1c5_20230524160726.gif"
                        />
                    </div>
                );
            case 2:
            case 6:
                return (
                    <div className="ai-correct-content">
                        <div className="ai-correct-contnet-header">
                            <img
                                className="ai-header-img"
                                src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202310/30/04c33_20231030162720.png"
                            />
                            <div style={{ width: 180 }}>
                                总得分: <span>{totalScore}</span> / {score}分
                            </div>
                            <div style={{ marginLeft: 50 }}>{totalScoreStr}</div>
                        </div>

                        <div className="ai-correct-main">
                            <div className="ai-answer-title ">你的回答</div>

                            <div className="ai-correct-card  ai-match-content">
                                <span dangerouslySetInnerHTML={{ __html: matchKeyWord() }}></span>
                            </div>

                            <div className="ai-analysis-title">AI解析：</div>
                            <div className="ai-correct-card ai-correct-analysis">{summary}</div>

                            <div className="ai-flex-item">
                                <div className="ai-comment">
                                    <div onClick={goComment}>
                                        意见反馈
                                        <img src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202308/15/75811_20230815154404.png" />
                                    </div>
                                </div>
                                <div className="ai-main-tip">
                                    温馨提示：总分由划线和非划线得分项组成，批改结果仅供参考。如有疑问，欢迎反馈。
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="ai-correct-failure">
                        <img
                            className="ai-header-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202308/03/7cbe5_20230803143010.png"
                        />
                        <div>批改失败，已退还批改次数，可能太拥挤啦，可稍后再来尝试</div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            {renderStatusContent()}
            {aiCorrect && [0, 1, 3].includes(aiCorrect.correctStatus) && (
                <div className="sub-tiku__question-right-statics">
                    <div className="sub-tiku__statics-title">我的答案：</div>
                    <div
                        className="sub-tiku__short-defalult-answer"
                        style={{ marginTop: 20 }}
                        dangerouslySetInnerHTML={{
                            __html: String(userValue || '-'),
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default CorrectAiContent;
